import I18nForLwText from './LwText'

export default class I18nForLwCascader extends I18nForLwText {
  name = 'lw-cascader'
}
